define('app/views/customer_register_success_view',['app/setup'], function(takhfifan) {
  takhfifan.customerRegisterSuccessView = takhfifan.BaseView.extend({

    initialize: function() {
      takhfifan.eventHub.on('customer:registered', function() {
        this.setResetSessionFlag();
        if (document.location.pathname.match(/customer\/account/)) {
          document.location.href= '/';
        } else {
          history.go(-1);
        }
        /*
        takhfifan.eventHub.trigger('message:show', {
          msg: i18n.t('register_success'),
          type: 'success'
        });
        _.delay(function() {
          history.go(-1);
        }, 4000);
        */
      }, this);
    },
  });
});

